import { Input } from 'antd'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { MyIcon } from '~/components/ui/MyIcon'
import { GET_HOT_KEYWORD } from '~/graphqls/gqls'
import { getHotKeyword } from '~/graphqls/types'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import useSearchParams from '~/hooks/useSearchParam'
// import Upload from './Upload'

import styles from './Search.module.css'

export default function Search() {
  const router = useRouter()
  const { keywords } = useSearchParams()
  const [text, setText] = useState('')
  const [hotList, setHotList] = useState<string[]>([])
  const getHotKeywordAction = useImperativeQuery<getHotKeyword>(GET_HOT_KEYWORD)
  const getHotKeyword = () => {
    getHotKeywordAction().then(res => {
      setHotList(res.data.aiArtworkResourceModule?.hotKeywordList || [])
    })
  }

  useEffect(() => {
    getHotKeyword()
  }, [])

  useEffect(() => {
    setText(keywords)
  }, [keywords])

  const handleEnter = () => {
    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          keywords: text,
        },
      },
      undefined,
      { shallow: true }
    )
  }

  const handleClear = () => {
    setText('')
    router.replace(
      {
        pathname: router.pathname,
        query: {
          keywords: '',
        },
      },
      undefined,
      { shallow: true }
    )
  }

  return (
    <div className="w-full">
      <div className="flex items-center h-[56px] bg-neutral-900 rounded-lg px-4">
        <MyIcon icon="search" className="text-[20px]"></MyIcon>
        <Input
          className={classNames(
            'h-[56px] !rounded-lg !border-none !shadow-none !text-neutral-300',
            styles.customInput
          )}
          placeholder="搜描述词 找AI创作"
          value={text}
          onChange={e => {
            setText(e.target.value)
          }}
          onPressEnter={handleEnter}
        />
        {text.length !== 0 && (
          <div
            className="text-neutral-400 text-sm flex-shrink-0 cursor-pointer"
            onClick={handleClear}
          >
            清空
          </div>
        )}
        {/* <div className="bg-neutral-600 w-px h-4 mx-3"></div>
        <div className="flex-shrink-0">
          <Upload />
        </div> */}
      </div>
      <div className="flex items-center justify-between text-neutral-900 text-xs mt-2 px-2">
        <span>
          <span>热门搜索：</span>
          {hotList.map((item, index) => {
            return (
              <span
                key={index}
                className="mr-2 cursor-pointer hover:text-primary"
                onClick={() => {
                  // setText(item)
                  router.replace(
                    {
                      pathname: router.pathname,
                      query: {
                        keywords: item,
                      },
                    },
                    undefined,
                    { shallow: true }
                  )
                }}
              >
                {item}
              </span>
            )
          })}
        </span>
        <div onClick={getHotKeyword}>
          <MyIcon
            icon="refresh"
            className="text-[14px] cursor-pointer"
          ></MyIcon>
        </div>
      </div>
    </div>
  )
}
